import * as React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { NamedCoreEnum } from 'Models';
import {
  DropDownList,
  DropDownListChangeEvent,
} from '@progress/kendo-react-dropdowns';
import { DropdownDbOption } from 'v3/Components/Form/Dropdown';
import { IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';

interface dataOption {
  text?: string;
  value: any;
}

export const DropdownFilterCell = (
  props: GridFilterCellProps,
  enums?: NamedCoreEnum,
  dbOptions?: DropdownDbOption[]
) => {
  const data = React.useMemo<dataOption[]>(() => {
    if (enums) {
      return Object.keys(enums).map((key) => {
        return { text: enums[key]?.displayName, value: enums[key].value };
      });
    }

    if (dbOptions && dbOptions.length > 0) {
      return dbOptions.map((x) => {
        return { text: x.name, value: x.id };
      });
    }

    return [];
  }, [enums, dbOptions]);

  const onChange = (e: DropDownListChangeEvent) => {
    props.onChange({
      value: e.value.value,
      operator: 'contains',
      syntheticEvent: e.syntheticEvent,
    });
  };

  const valueRender = (
    element: React.ReactElement<HTMLSpanElement>,
    value: any
  ) => {
    if (!value?.value) {
      return element;
    }

    const children = [
      <span key={1} className="dropdown-list-display-text">
        {element.props.children as any}
      </span>,
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          props.onChange({
            value: null,
            operator: 'contains',
            syntheticEvent: e,
          });
        }}
        edge="end"
        aria-label="Clear"
        id="clear"
      >
        <Clear fontSize="small" />
      </IconButton>,
    ];
    return <>{children}</>;
  };

  return (
    <div>
      <DropDownList
        style={{
          width: '300px',
          border: '1px solid #ccc',
          borderRadius: '4px',
        }}
        data={data}
        dataItemKey="value"
        textField="text"
        value={{
          text: data.find((x) => x.value === props.value)?.text,
          value: props.value,
        }}
        onChange={onChange}
        valueRender={valueRender}
        iconClassName={props.value ? 'd-none' : ''}
      ></DropDownList>
    </div>
  );
};
